import { useEffect, useRef, useState } from 'react';
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Box from '@mui/material/Box';
import { CustomButton } from '../../components/buttons'
import Input from '../../components/inputs/text-field-input'
import { Grid } from '@mui/material';
import { IsNullOrEmpty } from '../../core/utility';

interface DialogProps {
    show: boolean;
    phone: string;
    onSend: (code: string) => void;
    onClose: () => void;
}

const SmsCodeModal = (props: DialogProps) => {

    const { show, phone, onSend, onClose } = props;

    //states
    const [smsCode, setSmsCode] = useState<string>('');

    const [timer, setTimer] = useState(1500);
    const [start, setStart] = useState(false);
    const firstStart = useRef(true);
    const tick = useRef<NodeJS.Timeout>(); // <-- React ref

    useEffect(() => {
        if (show) {
            setTimer(300);
            setStart(true);
        }
    }, [show])

    useEffect(() => {
        if (firstStart.current) {
            firstStart.current = !firstStart.current;
            return;
        }
        if (start) {
            tick.current = setInterval(() => { // <-- set tick ref current value
                setTimer((timer) => timer - 1);
            }, 1000);
        } else {
            clearInterval(tick.current); // <-- access tick ref current value
        }

        return () => clearInterval(tick.current); // <-- clear on unmount!
    }, [start]);

    useEffect(() => {
        //console.log(timer);
        if (timer < 0 && start === true) {
            setStart(false);
            //console.log("durdu");
            handleClose();

            //clearInterval(tick.current)
        }
    }, [timer]);

    const handleSend = () => {
        onSend(smsCode);
        handleClose();
    }

    const handleClose = () => {
        clearInterval(tick.current);
        setSmsCode('');
        onClose();
    }

    const handleChange = (e: any) => {
        setSmsCode(e.target.value);
    }

    return (
        <Dialog open={show} scroll={'paper'} fullWidth={true} maxWidth="sm">
            <DialogContent>
                <Box>
                    <h4 style={{ color: '#177897', marginBottom: 10 }}>İşlemini tamamlamamız için bir adım kaldı.</h4>
                    <p>{phone} telefon numarasına gönderilen doğrulama kodunu giriniz.</p>
                </Box>
                <Grid container spacing={1}>
                    <Grid item flexGrow={1}>
                        <Input
                            id='smsCode'
                            name='smsCode'
                            caption='Sms Kodu'
                            value={smsCode}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item>
                        <CustomButton
                            text="DOĞRULA"
                            className='ks-button btn-primary'
                            disabled={IsNullOrEmpty(smsCode)}
                            onClick={handleSend} />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Box marginRight={2}>
                    {timer !== null && timer >= 0 && (
                        <div>Kalan Süre: {timer}</div>
                    )}
                </Box>
                <CustomButton
                    text="KAPAT"
                    className='ks-button btn-secondary'
                    onClick={handleClose} />
            </DialogActions>
        </Dialog>
    )
}

export default SmsCodeModal